import { MEMBER_PERMISSION } from "../../../../common/enum/member";
import {
    type ProductTypeIndexAnalyzeVo,
    type ProductTypeIndexCustomVo,
    type ProductTypeIndexDetailVo
} from "../../../../common/types";
import type { Page } from "../../../../common/types/base/BaseEntity";
import { BaseService } from "./baseService";
import httpRequest, { dataServiceHttpRequest } from "./index";
import type { ProductTypeIndex, ProductTypeIndexHotPagingParams } from "@zhihaoscm/entity";
import { decryptData, getPublicFileUrl, memberLimitDialog, validateMemberPermission } from "@/api/legacy";



export class IndexService extends BaseService<any, any, any, any> {
    public async indexPage(params: any): Promise<Page<ProductTypeIndexCustomVo>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, { params });
        return data;
    }

    /** 热门产品行情PC */
    public async hotPaging(params: ProductTypeIndexHotPagingParams): Promise<Page<ProductTypeIndexCustomVo>> {
        const { data } = await this.service.get(`${this.path}/hotPaging`, { params });
        return data;
    }

    public async getIndexInfo(id: string, date: string): Promise<ProductTypeIndexDetailVo[]> {
        if (!validateMemberPermission(MEMBER_PERMISSION.productTypeIndexRead.code)) {
            memberLimitDialog.open({
                blurImg: [getPublicFileUrl("index-detail-blur-1.png"), getPublicFileUrl("index-detail-blur-2.png")]
            });
        }
        const { data } = await this.service.get(`${this.path}/detail`, { params: { productTypeId: id, date } });
        return decryptData(data);
    }

    // 通过品类id和查询模式查询价格分析
    public async getPriceAnalysis(params: any): Promise<ProductTypeIndexAnalyzeVo[]> {
        if (!validateMemberPermission(MEMBER_PERMISSION.productTypeIndexRead.code)) {
            return [];
        }
        const { data } = await this.service.get(`${this.path}/custom-price-analysis`, { params });
        return data;
    }

    // 通过品类id和查询模式查询价格分析
    public async getShipmentAnalysis(params: any): Promise<ProductTypeIndexAnalyzeVo[]> {
        if (!validateMemberPermission(MEMBER_PERMISSION.productTypeIndexShipmentRead.code)) {
            return [] as ProductTypeIndexAnalyzeVo[];
        }
        const { data } = await this.service.get(`${this.path}/custom-shipment-analysis`, { params });
        return data;
    }

    // 获取最新砂石指数数据
    public async getLatest(productTypeId?: string): Promise<ProductTypeIndex> {
        let url = `${this.path}/latest`;
        if (productTypeId) url = url + `?productTypeId=${productTypeId}`;
        const { data } = await this.service.get(url);
        return data;
    }

    // 后端价格提醒消息 detailId 调整为砂石指数ID后，优先按ID精确查询跳转所需的品类和日期。
    public async getPriceWarningIndexById(id: string | number): Promise<ProductTypeIndexCustomVo | undefined> {
        // 价格提醒详情接口由 data-service 暴露，网关路径为 /dataService/custom/product-type-index/{id}。
        const { data } = await dataServiceHttpRequest.get(`${this.path}/${id}`, { silentError: true });
        return data;
    }

    // 置顶或取消置顶砂石指数
    async setProductTypeIndexTop(params: { productTypeId: string }): Promise<any> {
        enum TopType {
            PRODUCT_TYPE_INDEX = 1
        }
        const { data } = await this.service.post(`/top/top`, {
            businessId: params.productTypeId,
            type: TopType.PRODUCT_TYPE_INDEX
        });
        return data;
    }
}
export const indexService = new IndexService("/product-type-index", httpRequest);
